import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Logger } from '@shared/common/logger';
import { BehaviorSubject } from 'rxjs';
import { getBookByAlias } from 'src/app/data/books/utils';
import type { IBookPreview } from '@shared/jp/data/products';
import type { TBookAlias } from '@shared/jp/product';
import type { ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP } from '@shared/jp/maps';
import {
  BOOK_ALIAS_LETS_MAKE_METRO,
  BOOK_ALIAS_TOKYO_METRO,
  BOOK_ALIAS_THIS_IS_MY_DREAM_LINE,
} from '@shared/jp/product';
import { MAKE_MAP } from '../../data/books/TokyoMetro';

const log = new Logger('PreviewPageComponent');

@Component({
  templateUrl: './preview-page.component.html',
  styleUrls: ['./preview-page.component.scss'],
})
export class PreviewPageComponent implements OnInit {
  private _book = new BehaviorSubject<IBookPreview | undefined>(undefined);

  public book = this._book.asObservable();

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
  ) {}

  private ROUTE_PATH_ALIAS_TOKYO_METRO_BOOK_MAP = MAKE_MAP<
    (typeof ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP)[keyof typeof ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP]
  >()({
    'tokyo-metro': BOOK_ALIAS_TOKYO_METRO,
    'lets-make-metro': BOOK_ALIAS_LETS_MAKE_METRO,
    'this-is-my-dream-line': BOOK_ALIAS_THIS_IS_MY_DREAM_LINE,
  });

  ngOnInit(): void {
    this._route.params.subscribe((p) => {
      const { alias: pathName } = p;
      const path = this._route.routeConfig?.path;

      this._loadBook(
        this.ROUTE_PATH_ALIAS_TOKYO_METRO_BOOK_MAP[
          pathName as keyof typeof this.ROUTE_PATH_ALIAS_TOKYO_METRO_BOOK_MAP
        ] || path,
      );
    });
  }

  private _loadBook(alias?: TBookAlias | string): void {
    try {
      const book = getBookByAlias(alias as TBookAlias);

      this._book.next(book);
    } catch (err) {
      log.error(err);
      this._router.navigate(['404']).catch((_err) => log.error(_err));
    }
  }
}
